/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import FatsacColors from "./fatsac-colors";

// @ts-ignore
import {GenerateProductAssetUrl} from "./../../themes/kent/utilities/functions";
// @ts-ignore
import {GeneralAssetUrl} from "./../../themes/kent/utilities/constants";

interface IState {
  fatsacProductWeight?: any;
  fatsacSizes?: any;
  fatsacImage?: any;
}

interface IProps {
  product?: any;
  year?: any;
}

/**
 *
 * WakeboardSpecs component
 * @extends {React.PureComponentReact.Component<IProps,IState>}
 */

class FatsacSpecs extends React.Component<IProps,IState> {
  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  public componentDidMount = async () => {
    if(this.props.product){
        this.setUpScreen(this.props.product);
    }
  }

  public setUpScreen = async(product:any) =>{
    let prodAssetUrl:any = await GenerateProductAssetUrl(product,this.props.year);
    if(product.attributes){
      if(product.attributes.subcategory == "g7lQZjE06q"){
  			let descriptions:any =["Length in Inches","Height in Inches","Width in Inches"]
  			let fatsacSizes:any = [];
  			let sizes:any = null;
  			if(product.attributes.sizes){
  				sizes = product.attributes.sizes[0].split(',');
  			}
  			var productImage:any = prodAssetUrl+product.attributes.slug+'1.png';
  			var fatsacProductWeight:any = product.attributes.fatsacProductWeight;
  			sizes.map((size:any,index:any) =>{
  				fatsacSizes.push({
  					'size':size,
  					'description':descriptions[index]
  				})
  				if(index == sizes.length -1){
  					this.setState({
  						fatsacProductWeight:fatsacProductWeight,
  						fatsacSizes:fatsacSizes,
  						fatsacImage: productImage
  					})
  				}
  			})
  		}
    }
	}

  public render(): JSX.Element {
		if(!this.state.fatsacSizes) return <span />;
		return (
      <div className="white-background section-padding" style={{paddingBottom:"0px"}}>
				<div className="row max-width-container ">
					{this.state.fatsacProductWeight &&
						<div className="small-12 medium-6">
							<div className="small-padding" style={{height:'100%'}}>
								<div className="white-background small-padding centered-text row shadow"  style={{height:'100%', alignItems:'center', justifyContent:'center'}}>
									<div className="center-position centered-text">
										<h1 className="product-detail-boom-font" id="total-weight">{this.state.fatsacProductWeight}</h1>
										<p className="subheading">{'Total ballast weight at recomended capacity'}</p>
									</div>
								</div>
							</div>
						</div>
					}
					{this.state.fatsacSizes &&
						<div className="small-12 medium-6">
							<div className="small-padding">
								<div className="white-background small-padding centered-text shadow">
									<h2>{'Dimensions'}</h2>
									<hr style={{"opacity" :".15"}} />
									<div className="row">
										{this.state.fatsacSizes.map((size:any,index:any) =>{
											return(
												<div className="small-12 medium-4" style={{"padding":"5px"}}>
													<div className="white-background centered-text" style={{"padding":"5px"}}>
														<h1 style={{"marginBottom":"0px"}}>{size.size}</h1>
														<p className="subheading">{size.description}</p>
													</div>
												</div>
											)
										})}
									</div>
								</div>
							</div>
						</div>
					}
				</div>
        <div className="section-padding">
          <div className="row full-width small-max-width-container" style={{alignItems:'center', justifyContent:'cetner'}}>
            {this.props.product && <FatsacColors product={this.props.product} />}
          </div>
        </div>
			</div>
		)
  }
}

export default FatsacSpecs;
